import styled from 'styled-components'
import {seaNavy, darkGray} from '@modifi/colors'

export const Headline = styled.div`
  font-weight: 600;
  color: ${seaNavy};
  line-height: 1.25;
  font-size: 32px;
  text-align: center;
`

export const Description = styled.div`
  color: ${darkGray};
  text-align: center;
  line-height: 1.5;
  font-size: 16px;
`
